import { useMemo } from "react"
import { DataTypeList, Standards } from "../../../../../features/data-types"
import { PanelWrapper, Column, FieldType, UIPermission, O } from "../../../../../features/ui"
import { BookmarkButton } from "../../../../../features/bookmarks"
import { RoutePath } from "../../../../../features/routes"
import { useFind } from "../../../../../state/reducers/hooks"
import { TableName } from "../../../../../tables"
import { useSystemStateHooks } from "../../../../system"
import { ExpenseType } from "../../../state/types"
import { useExpenseTypeLoaders } from "../../../loaders/expenseTypeLoaders"

export const ExpenseTypeList = () => {
    const { userHasPermission } = useSystemStateHooks()
    const readOnly = !userHasPermission(UIPermission.SAVE_EXPENSE_TYPES)
    const find = useFind()
    
    const expenseTypeLoaders = useExpenseTypeLoaders()

    const rows = useMemo(() => expenseTypeLoaders().findAllExpenseTypes(true), [])

    const columns: Column[] = [
        { name: 'name', type: FieldType.TEXT, label: 'Nombre' }
    ]

    const isEditable = (rowIdValue?: string) => {
        const expenseType = find(TableName.EXPENSE_TYPES, rowIdValue) as O<ExpenseType>
        return expenseType?.name !== Standards.SalaryExpenseTypeName
    }

    return (
        <PanelWrapper title="Tipos de Gasto" titleRight={<BookmarkButton routePath={RoutePath.EXPENSE_TYPES} />}>
            <DataTypeList
                columns={columns}
                rows={rows}
                readOnly={readOnly}
                minItems={1}
                showDetail={false}
                isEditable={isEditable}
            />
        </PanelWrapper>
    )
}
